// src/pages/B2B/event-reports/api/useEventReports.ts
import { useCallback, useEffect, useState } from 'react';
import type { Env } from '@/pages/Admin/shared';
import { useAdminApi } from '@/pages/Admin/shared/adminApi';
import type { EventReportRecord } from '../types';

interface ListResult {
  items: EventReportRecord[];
  total: number;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useEventReports(env: Env): ListResult {
  const { request } = useAdminApi();
  const [items, setItems] = useState<EventReportRecord[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const json = await request<{ items?: EventReportRecord[]; total?: number }>({
        env,
        path: '/admin/event-reports',
        query: { limit: 200 },
      });
      setItems(json.items ?? []);
      setTotal(json.total ?? 0);
      setError(null);
    } catch (e: any) {
      setItems([]);
      setTotal(0);
      setError(e?.message ?? 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, [request, env]);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { items, total, loading, error, refetch };
}
